import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { DamageStatusDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-damage-status-container',
  templateUrl: './damage-status-container.component.html',
  styleUrls: ['./damage-status-container.component.scss'],
})
export class DamageStatusContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  damagestatuss$: Observable<DamageStatusDto[]>;
  loading: boolean;
  isLoadingDamageStatus$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingDamageStatus$ = this.gatwayFacade.isLoadingGateway(
      'DamageStatus'
    );
    this.damagestatuss$ = this.gatwayFacade.loadGateway('DamageStatus');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteDamageStatus(deletedValue: any) {
    this.gatwayFacade.remove('DamageStatus', deletedValue);
  }

  // this method control both the create and update

  onSubmitDamageStatus(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.DamageStatuss;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllDamageStatus = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllDamageStatus.push(pullData[i]);
      }
    }

    // check if the addAllDamageStatus array is not empty, then dispatch the data to the store
    if (addAllDamageStatus.length > 0) {
      this.gatwayFacade.add('DamageStatus', addAllDamageStatus);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('DamageStatus', allUpdates, ['id']);
    }
  }
}
